import { render, staticRenderFns } from "./SvehiclesalesorderCreate.vue?vue&type=template&id=6b61f616&scoped=true"
import script from "./SvehiclesalesorderCreate.vue?vue&type=script&lang=js"
export * from "./SvehiclesalesorderCreate.vue?vue&type=script&lang=js"
import style0 from "./SvehiclesalesorderCreate.vue?vue&type=style&index=0&id=6b61f616&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b61f616",
  null
  
)

export default component.exports